import React from 'react'
import './Footer.css';
const Footer = () => {
  return (
    <div className='footer'>
<h2 className='headd'>Pushpraj Dubey</h2>
<div className="social">
          
          <ul>
            <li>
              <a href="https://github.com/Pushpraj45">
                <i class="fa-brands fa-github"></i>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/pushpraj-dubey-915aa4226/">
                <i class="fa-brands fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/Pushpra50588222">
                <i class="fa-brands fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/">
                <i class="fa-brands fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>


    </div>
  )
}

export default Footer